import React from 'react';
import {
  StatusAborted,
  StatusError,
  StatusOK,
  StatusPending,
  StatusRunning,
  StatusWarning,
} from '@backstage/core-components';

type StatusChipProps = {
  value?: string;
};

export const StatusChip = ({ value }: StatusChipProps) => {
  const v = String(value || '').toUpperCase();

  // Build statuses
  if (v === 'SUCCESS' || v === 'COMPLETED') return <StatusOK>{value}</StatusOK>;
  if (
    v === 'FAILURE' ||
    v === 'FAILED' ||
    v === 'TIMEOUT' ||
    v === 'INTERNAL_ERROR'
  )
    return <StatusError>{value}</StatusError>;
  if (v === 'WORKING') return <StatusRunning>{value}</StatusRunning>;
  if (v === 'QUEUED') return <StatusPending>{value}</StatusPending>;
  if (v === 'CANCELLED') return <StatusAborted>{value}</StatusAborted>;

  // Log severity levels (Cloud Logging)
  if (v === 'INFO' || v === 'NOTICE' || v === 'DEFAULT' || v === 'DEBUG')
    return <StatusOK>{value}</StatusOK>;
  if (v === 'WARNING' || v === 'WARN')
    return <StatusWarning>{value}</StatusWarning>;
  if (
    v === 'ERROR' ||
    v === 'CRITICAL' ||
    v === 'ALERT' ||
    v === 'EMERGENCY' ||
    v === 'ERR'
  )
    return <StatusError>{value}</StatusError>;

  return <StatusWarning>{value}</StatusWarning>;
};
